import React from "react";
import { THEME_COLORS } from "../themes/DarkLight";
import useThemeHook from "../hooks/useThemeHook";
import { useTranslationHook } from "../hooks/useTranslationHook";

function TextField({
  type = "text",
  title,
  placeHolder,
  maxLength,
  text,
  setText,
  padding,
  contentPosition = "left",
  contentWeight = "normal",
  contentSize = "16px",
  backgroundColor,
  readOnly = false,
  multiline = false,
}: {
  type?: string | null;
  title?: string | undefined;
  placeHolder: string;
  maxLength?: number | undefined;
  text: string | undefined | null;
  setText: Function;
  padding?: string | undefined;
  contentPosition?: "left" | "center" | "right" | null;
  contentWeight?: string | undefined;
  contentSize?: string | undefined;
  backgroundColor?: string | undefined;
  readOnly?: boolean;
  multiline?: boolean;
}) {
  const theme = useThemeHook();
  const textLength = text ? text.length : 0;
  const getTranslationText = useTranslationHook();

  return (
    <div style={{ padding: padding, width: "100%" }}>
      {title && <p>{title}</p>}

      {multiline ? (
        <textarea
          value={text !== null ? text : ""}
          style={{
            textAlign: contentPosition || "left",
            fontSize: contentSize,
            marginBottom: "5px",
            fontWeight: contentWeight,
            borderRadius: "30px",
            padding: "5px",
            width: "100%",
            minHeight: "100px",
            border: "none",
            backgroundColor: backgroundColor || THEME_COLORS[theme].less_theme,
            color: THEME_COLORS[theme].inverse_theme,
          }}
          placeholder={placeHolder}
          maxLength={maxLength}
          onChange={(e) => setText(e.target.value)}
          readOnly={readOnly}
        />
      ) : (
        <input
          type={type ?? "text"}
          value={text !== null ? text : ""}
          style={{
            textAlign: contentPosition ?? "left",
            fontSize: contentSize,
            marginBottom: "5px",
            fontWeight: contentWeight,
            borderRadius: "30px",
            padding: "5px",
            paddingLeft: "10px",
            paddingRight: "10px",
            width: "100%",
            height: "50px",
            border: "none",
            backgroundColor: backgroundColor || THEME_COLORS[theme].less_theme,
            color: THEME_COLORS[theme].inverse_theme,
          }}
          placeholder={placeHolder}
          maxLength={maxLength}
          onChange={(e) => setText(e.target.value)}
          readOnly={readOnly}
        />
      )}

      {maxLength && (
        <p
          style={{ color: THEME_COLORS[theme].inverse_theme, fontSize: "12px" }}
        >
          {getTranslationText("characters_left", {
            number: maxLength - textLength,
          })}
        </p>
      )}
    </div>
  );
}

export default TextField;
